module.exports = __webpack_public_path__ + "img/goal.88393b16.png";